import * as constantes from "../constants/constantes";
const ENDPOINT = constantes.URLAPI;
const ENDPOINTTEST = constantes.URL_TESTMATERIAL;


export const DescargarListaMaterialesCurso = async ({jwt,idCurso}) =>{
    return await fetch(`${ENDPOINT}/ZADMaterial/DescargarListaMaterialesCurso/${idCurso}`,{
    //return await fetch(`${ENDPOINTTEST}/DescargarListaMaterialesCurso/${idCurso}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

export const DescargarListaMaterialesUnidad = async ({jwt,idUnidad}) =>{
    return await fetch(`${ENDPOINT}/ZADMaterial/DescargarListaMaterialesUnidad/${idUnidad}`,{
    //return await fetch(`${ENDPOINTTEST}/DescargarListaMaterialesUnidad/${idUnidad}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

export const ListarMaterialesPorLeccion = async({jwt,idLeccion})=> {
    return await fetch(`${ENDPOINT}/ZADMaterial/ListarMaterialesPorLeccion/${idLeccion}`,{
    //return await fetch(`${ENDPOINTTEST}/ListarMaterialesPorLeccion/${idLeccion}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

export const ListarMaterialesCurso = async({jwt,idCurso})=> {
    return await fetch(`${ENDPOINT}/ZADMaterial/ObtenerListaMaterialesCurso/${idCurso}`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerListaMaterialesCurso/${idLeccion}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

export const ObtenerListaMaterialesUnidad = async({jwt,idUnidad})=> {
    return await fetch(`${ENDPOINT}/ZADMaterial/ObtenerListaMaterialesUnidad/${idUnidad}`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerListaMaterialesCurso/${idLeccion}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}